<template>
  <div class="CurriculumSetMealInfo sw-container">
    <div class="common-nav">
      <span class="s1">您的位置</span>
      <span class="s2">|</span>
      <span class="s3">选课中心</span>
    </div>
    <div class="CurriculumSetMealInfo-item">
      <img
        v-if="dataInfo.imgurl"
        class="CurriculumSetMealInfo-img"
        :src="dataInfo.imgurl"
      />
      <!-- <img
        v-else
        class="CurriculumSetMealInfo-img"
        src="../../assets/img/balance.png"
      /> -->
      <div class="CurriculumSetMealInfo-font">
        <div class="CurriculumSetMealInfo-p1">
          <span class="CurriculumSetMealInfo-name">{{ dataInfo.name }}</span>
          <span class="CurriculumSetMealInfo-money"
            >￥ {{ dataInfo.money }}</span
          >
        </div>
        <div class="CurriculumSetMealInfo-p2">购买学时,享受更多服务</div>
        <div class="CurriculumSetMealInfo-btn" @click.stop="goPay(dataInfo.id)">
          点击购买
        </div>
      </div>
    </div>
    <div class="CurriculumSetMealInfo-main">
      <div class="CurriculumSetMealInfo-main-l">
        <div class="CurriculumSetMealInfo-title">套餐详情</div>
        <div v-html="dataInfo.detail"></div>
      </div>
      <div class="CurriculumSetMealInfo-main-r">
        <div class="CurriculumSetMealInfo-main-r-bg">
          <div class="CurriculumSetMealInfo-title">其他套餐</div>
          <template v-for="i in hotData">
            <div class="CurriculumSetMealInfo-box">
              <img class="CurriculumSetMealInfo-box-img" :src="i.imgurl" />
              <div class="CurriculumSetMealInfo-box-title">
                {{ i.name }}
              </div>
              <div class="CurriculumSetMealInfo-box-browse">
                购买学时,享受更多服务
              </div>
              <div class="CurriculumSetMealInfo-box-bottom">
                <div
                  class="CurriculumSetMealInfo-box-btn"
                  @click.stop="goPay(i.id)"
                >
                  点击购买
                </div>
                <div class="CurriculumSetMealInfo-box-money">
                  ￥ {{ i.money }}
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "@/assets/api/api.js";
export default {
  name: "CurriculumSetMealInfo",
  components: {},
  data() {
    return {
      dataInfo: {},
      hotData: [],
    };
  },
  created() {
    this.getData();
    this.recommend();

    api.EventBus.$emit("changeNav", 1);
  },
  computed: {},
  methods: {
    getData() {
      api.showLoading();
      api
        .postData("sale/comboDetail", {
          comboId: this.$route.query.cid,
        })
        .then((res) => {
          this.dataInfo = res.data;
        });
    },
    recommend() {
      api.postData("sale/recommend", {}).then((res) => {
        this.hotData = res.data;
      });
    },
    goPay(id) {
      this.$router.push({
        path: "/OrderOk",
        query: {
          cid: this.$route.query.cid,
        },
      });
    },
    handleChangePage() {},
  },
  watch: {},
};
</script>

<style lang="scss">
.CurriculumSetMealInfo {
  padding-bottom: 37px;
  &-main {
    display: flex;
    justify-content: space-between;
    &-l {
      width: 900px;
      background: #fff;
      padding: 20px;
    }
    &-r {
      width: 280px;
      &-bg {
        padding: 20px;
        background: #fff;
      }
    }
  }
  &-box {
    border-bottom: 1px solid #eeeeee;
    padding-bottom: 15px;
    margin-bottom: 20px;
    &-img {
      width: 100%;
      display: block;
    }
    &-title {
      font-size: 16px;
      color: #222222;
      line-height: 1;
      margin-top: 12px;
    }
    &-browse {
      color: #999999;
      font-size: 14px;
    }
    &-bottom {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &-btn {
      width: 80px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      font-size: 14px;
      color: #fff;
      background: #ec6941;
      border-radius: 3px;
      cursor: pointer;
    }
    &-btn:hover {
      background: rgba(236, 105, 65, 0.8);
    }
    &-money {
      color: #ec6941;
      font-weight: bold;
      font-size: 18px;
    }
  }
  &-title {
    line-height: 1;
    font-size: 16px;
    border-left: 2px solid #31af58;
    padding-left: 10px;
    margin-bottom: 10px;
  }
  &-item {
    background: #fff;
    display: flex;
    padding: 20px 30px 20px 20px;
    margin-bottom: 12px;
    transition: all 0.3s ease-in-out;
  }
  &-item:hover {
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
    border-color: #eee;
  }
  &-img {
    width: 200px;
    height: 120px;
    margin-right: 30px;
  }
  &-font {
    flex: 1;
  }
  &-p1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &-name {
    color: #222222;
    font-size: 18px;
  }
  &-money {
    color: #ec6941;
    font-size: 30px;
    font-weight: bold;
  }
  &-p2 {
    color: #999999;
    font-size: 14px;
  }
  &-btn {
    width: 100px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    font-size: 14px;
    color: #fff;
    margin-top: 30px;
    background: #ec6941;
    border-radius: 3px;
    cursor: pointer;
  }
  &-btn:hover {
    background: rgba(236, 105, 65, 0.8);
  }
}
</style>
